'use strict';

exports.__esModule = true;

var _glamor = require('glamor');

var _ = require('..');

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Container
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
var fontKerning = (0, _glamor.css)({
  fontKerning: 'normal',
  fontVariantLigatures: 'common-ligatures contextual',
  fontFeatureSettings: '"kern", "liga", "clig", "calt"'
}).toString();

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------- Components
// ------------------------------------------------------------------------------
/**
 * [description]
 * @param  {[type]} options.kit       [description]
 * @param  {Object} options.options} [description]
 * @return {[type]}                   [description]
 */


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Type generators
var typeFn = function typeFn() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      kit = _ref.kit,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options;

  var pClass = (0, _.generateParagraphType)(kit, options);
  var hClass = (0, _.generateHeadingType)(kit, options);
  var className = pClass + ' ' + hClass + ' ' + fontKerning;
  return className;
};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = typeFn;
module.exports = exports['default'];